

















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import sub from 'date-fns/sub/index';
import formatDistanceToNow from 'date-fns/formatDistanceToNow/index';
import { addMinutes, differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds, addSeconds } from 'date-fns';

@Component
export default class CopyCountdown extends Vue {
  @Prop()
  private time!: number;

  @Prop({ default: 'default' })
  private timeFormat!: string;

  @Prop({
    default: () => ({
      showDays: true,
      showHours: true,
    })
  })
  private options!: any;

  private timerEndsIn: any = new Date();
  private timerEndsAt: any = new Date();
  private timerStartedAt: any = new Date();
  private timeCurrent: any = new Date();
  private interval: any = () => {};

  private get totalSeconds () {
    const difference = differenceInSeconds(this.timerEndsAt, this.timeCurrent);

    return difference > 0 ? difference : 0;
  }

  private get countDown () {
    const days = this.totalSeconds / 86400;
    const hours = this.totalSeconds / 3600;
    const minutes = this.totalSeconds / 60;

    const realDays =  Math.floor(days - (days % 1));
    const realHours =  Math.floor(hours / 24 % 1 * 24);
    const realMinutes = Math.floor(minutes / 60 % 1 * 60);
    const realSeconds = Math.round((minutes % 1) * 60);

    const addExtraZeroWhenNeed = (value: number): number|string => {
      return value < 10 ? `0${value}` : value;
    };

    return {
      days: addExtraZeroWhenNeed(realDays),
      hours: addExtraZeroWhenNeed(realHours),
      minutes: addExtraZeroWhenNeed(realMinutes),
      seconds: addExtraZeroWhenNeed(realSeconds),
    };
  }

  public get isFinished () {
    return this.totalSeconds <= 0;
  }

  private unitFormated (unit: number|string, type: string) {
    return `${unit}${this.$i18n.t(`App.dates.${type}.${this.timeFormat}`)}`;
  }

  @Watch('isFinished')
  onFinishCountdown (isFinished: boolean) {
    if (isFinished) {
      this.$emit('onFinish', isFinished);
    }
  }

  private mounted () {
    clearInterval(this.interval);

    this.timerEndsAt = addMinutes(this.timerEndsAt, this.time);

    this.interval = setInterval(() => {
      this.timeCurrent = addSeconds(this.timeCurrent, 1);
    }, 1000);
  }

  private destroy () {
    clearInterval(this.interval);
  }
}
